import { Fragment } from 'react';

import Icon, { IconName } from '@/components/Icon/Icon';
import Link from '@/components/Link/Link';
import {
  type Contentful,
  ContentStyle,
  type FooterMenuContent,
} from '@/contentful';

import useStyles from './GlobalMinimalFooter.styles';
export interface GlobalMinimalFooterContent extends Contentful {
  fields: {
    copyrightText: string;
    legalLinks: FooterMenuContent;
    variant: 'light' | 'dark';
    style: ContentStyle;
  };
}
export interface GlobalMinimalFooterProps {
  content: GlobalMinimalFooterContent;
}

const GlobalMinimalFooter: React.FC<GlobalMinimalFooterProps> = ({
  content: {
    fields: { copyrightText, legalLinks, style },
  },
}: GlobalMinimalFooterProps) => {
  const isOnDark = style === ContentStyle.OnDark;
  const { classes } = useStyles({ isOnDark });
  return (
    <footer className={classes.container}>
      <div className={classes.copyright}>{copyrightText}</div>
      <div className={classes.legalLinks}>
        {legalLinks.fields.links?.map(
          ({ fields: { text, url } }, index, array) => (
            <Fragment key={text}>
              <Link
                className={`${classes.legalLink} ${
                  text === 'Your Privacy Choices'
                    ? classes.legalLinkPrivacy
                    : ''
                }`}
                href={url}
              >
                {text}
              </Link>
              {text === 'Your Privacy Choices' && (
                <div
                  className={classes.privacyOptions}
                  data-testid='privacy-options'
                >
                  <Icon name={IconName.PRIVACY_OPTIONS} width={24} />
                </div>
              )}
              {index < array.length - 1 && (
                <span className={classes.legalLinkSlash}>/</span>
              )}
            </Fragment>
          )
        )}
      </div>
    </footer>
  );
};

export default GlobalMinimalFooter;
